import Flickity from 'flickity';

let options = {
  cellSelector: ".slide",
  cellAlign: 'left',
  groupCells: 1,
  draggable: true,
  prevNextButtons: true,
  pageDots: true
}

// enable prev/next buttons at 768px
if ( matchMedia('screen and (min-width: 767px)').matches ) {
  options.groupCells = 2;
  options.pageDots = false;
  options.prevNextButtons = false;
}

// enable prev/next buttons at 768px
if ( matchMedia('screen and (min-width: 1024px)').matches ) {
  options.groupCells = 3;
}

const overlapSlider = () => {
  let flky = new Flickity(".overlapSlider", { ...options });
  flky;
};

export default overlapSlider;


// WEBPACK FOOTER //
// ./src/js/app/components/OverlapSlider.js